import axios from 'axios'
import { router } from '@/router/router.js'
import { Notify, Dialog } from 'vant'

// 创建axios请求实例
const Token = localStorage.Token ? localStorage.Token : ''
const request = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? process.env.prop_url : process.env.dev_url,
  // baseURL: process.env.NODE_ENV === process.env.dev_url,
  // withCredentials: true, // send cookies when cross-domain requests
  headers: {
    'Token': Token
  },
  timeout: 10000, // request timeout
  transformRequest: [function (data) {
    let ret = ''
    for (const it in data) {
      if (data[it] != null) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
    }
    ret = ret.substr(0, ret.length - 1)
    return ret
  }]
})

// 添加请求拦截器
request.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  const Token = localStorage.Token ? localStorage.Token : ''
  // 为每个请求添加token请求头
  config.headers['Token'] = Token
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})
console.log(request.interceptors.response),
// 添加响应拦截器
// response interceptor
request.interceptors.response.use(
  // 
  response => {
    const res = response.data
    // if the custom code is not 0, it is judged as an error.

    if (res.code !== 0) {

      if (res.code === '50008' || res.code === '50012' || res.code === '50014') {
        // 您的登录已失效，请重新登录。

        Dialog.alert({
          message: '您的登录已失效，请重新登录。'
        }).then(() => {
          // on close
          localStorage.removeItem('changes')
          localStorage.removeItem('Token')
          location.reload()
        })
      }
      if (res.code === '500') {
        Dialog.alert({
          message: '您的用户不存在/密码错误。'
        }).then(() => {
          // on close
          localStorage.removeItem('changes')
          localStorage.removeItem('Token')
          location.reload()
        })
      }
      // Notify({ type: 'danger', message: res.msg || 'Error' })
      //
      if (response.config.url.includes('api/login')) {
        return res
      }
      Notify({ type: 'danger', message: res.msg })
      return Promise.reject(new Error(res.msg || '错误'))
    } else {
      return res
    }
  },

  error => {
    Notify({ type: 'danger', message: '请求失败，请刷新或重试' })
    return Promise.reject(error)
  }
)

export default request
